// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M16.8126 3.0198L12.6787 5.27884L16.9056 7.58686V14.5298L21.0599 16.8865V5.27884L16.8126 3.0198Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12.6787 18.4196V13.9797L21.0646 18.695L17.1788 20.9169L12.6787 18.4196Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7.46202 20.917L11.5959 18.6579L7.36901 16.3499L7.36902 9.40696L3.21465 7.05028L3.21465 18.6579L7.46202 20.917Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.5959 5.5171V9.95702L3.20996 5.24166L7.09576 3.01978L11.5959 5.5171Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-hiflow-filled')
export default class LogoHiflowFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-hiflow-filled',
    }
  }
}
